import { render } from "./CashdeskDatatableTDSalesCard.vue?vue&type=template&id=f7faeba2"
import script from "./CashdeskDatatableTDSalesCard.vue?vue&type=script&lang=js"
export * from "./CashdeskDatatableTDSalesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__